import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuth } from './use-auth'
import type { Usuario } from '@/types'

export interface Membro extends Usuario {
  // Campos específicos para exibição na lista de membros
  displayName?: string
}

export function useMembros() {
  const { perfil } = useAuth()

  return useQuery({
    queryKey: ['membros', perfil?.igreja_id],
    queryFn: async (): Promise<Membro[]> => {
      if (!supabase) {
        throw new Error('Supabase client not initialized')
      }

      if (!perfil?.igreja_id) {
        throw new Error('Igreja não identificada')
      }

      const { data, error } = await supabase
        .from('usuarios')
        .select('*')
        .eq('igreja_id', perfil.igreja_id)
        .eq('ativo', true)
        .order('nome')

      if (error) {
        throw new Error(`Erro ao buscar membros: ${error.message}`)
      }

      return data || []
    },
    enabled: !!perfil?.igreja_id && !!supabase,
  })
}